import {
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import { CognitoIdentityProvider } from "@aws-sdk/client-cognito-identity-provider";
import { getCognitoBrandClientMetadata } from "../features/auth/config/brandOverride";

export class CognitoHelper {
  private readonly userPool: CognitoUserPool;
  private readonly cognitoIdentityProvider: CognitoIdentityProvider;
  private readonly userPoolId: string;

  constructor() {
    this.userPool = new CognitoUserPool({
      UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
      ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
    });
    this.userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID!
    this.cognitoIdentityProvider = new CognitoIdentityProvider({
      region: "us-west-2",
    });
  }

  /**
   * Sign In not required Action
   * @param userAttribute
   * @param validationAttributes
   * @param email
   * @param password
   */
  public signUp(
    userAttribute: Array<CognitoUserAttribute>,
    validationAttributes: Array<CognitoUserAttribute>,
    userName: string,
    password: string,
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userPool.signUp(
        userName,
        password,
        userAttribute,
        validationAttributes,
        (err: any, result?) => {
          if (err) {
            console.error("Failed: User adding to the pool - " + err);
            reject(err);
          }

          resolve(undefined);
        },
      );
    });
  }

  public confirmRegistration(userName: string, authCode: string) {
    const currentUser = new CognitoUser({
      Username: userName,
      Pool: this.userPool,
    });
    return new Promise((resolve, reject) => {
      currentUser.confirmRegistration(authCode, false, (err, result) => {
        if (err) {
          reject(err);
        }
        // @ts-ignore
        resolve(undefined);
      });
    });
  }

  public resendConfirmationCode(userName: string) {
    const currentUser = new CognitoUser({
      Username: userName,
      Pool: this.userPool,
    });
    return new Promise((resolve, reject) => {
      currentUser.resendConfirmationCode((err, result) => {
        if (err) {
          reject(err);
        }
        // @ts-ignore
        resolve(undefined);
      }, getCognitoBrandClientMetadata());
    });
  }
}
